import { Outlet, useNavigation, useOutlet } from 'react-router-dom';
import { Footer, Header } from 'components/molecules';
import { CLottie, PageTitle } from 'components/atoms';
import { useAppSelector } from 'hooks/redux';

const AuthPagesLayout = () => {
  console.log('AuthPagesLayout');
  const { state } = useNavigation();
  const { isPageTitleVisible } = useAppSelector((state) => state.app);
  const outletData = useOutlet();
  const { title, children } =
    outletData?.props?.children?.props?.children?.props?.children?.props?.children?.props ??
    outletData?.props?.children?.props?.children?.props ??
    {};

  return (
    <div className="flex h-screen max-w-full flex-col overflow-x-hidden">
      <Header isAuthPage />

      <main className="m-2 flex flex-1 flex-col overflow-y-auto xs:mx-4 xs:my-6 lg:mx-9">
        {state === 'loading' ? (
          <CLottie isFullPage />
        ) : (
          <>
            {title && isPageTitleVisible && <PageTitle title={title}>{children ?? null}</PageTitle>}

            <Outlet />
          </>
        )}
      </main>

      <Footer isAuthPage />
    </div>
  );
};

export default AuthPagesLayout;
